const { zIndex } = require("tailwindcss/defaultTheme")

module.exports = {
  spacing: require("./spacing/spacing"),
  screens: require("./screens/screens"),
  colors: require("./colors/colors"),
  fontFamily: require("./fontFamily/fontFamily"),
  shadow: require("./shadow/shadow"),
  spacingUtilities: require("./spacing/spacingUtilities"),
  zIndex: {
    ...zIndex,
    1: "1",
    2: "2",
    max: "2147483647",
  },
  extend: {
    keyframes: require("./keyframes"),
    boxShadow: {
      xs: "0px 8px 16px 0px #0810C60D",
    },
  },
}
